import type { TrackSourceKind } from '@/lib/db';

export const SOURCE_LABEL: Record<TrackSourceKind, string> = {
  'fr24-kml': 'FR24 KML',
  'fr24-csv': 'FR24 CSV',
  gpx: 'GPX',
  igc: 'IGC',
  geojson: 'GeoJSON',
  'fr24-api': 'FR24 API',
  opensky: 'OpenSky',
  adsb: 'ADS-B',
};
